import React, {FC} from 'react';

import {SignatureModel} from '../../../models/api/signatureModel';
import {TeamModel} from '../../../models/api/teamModel';
import {maybeRenderAccessory} from './settingsSearchAccessoryHelpers';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchDropdownGenericItem} from './settingsSearchDropdownGenericItem';

/*
 * Props.
 */

interface SettingsSearchDropdownSignatureItemProps extends SettingsSearchDropdownItemBaseProps {
  signature: SignatureModel;
  team?: TeamModel;
}

/*
 * Component.
 */

export const SettingsSearchDropdownSignatureItem: FC<SettingsSearchDropdownSignatureItemProps> = (props) => {
  const {signature, team, onSelect} = props;

  return (
    <SettingsSearchDropdownGenericItem
      label={signature.name}
      onSelect={onSelect}
      iconName="featherSmall"
      title={
        <>
          {signature.name}
          {maybeRenderAccessory(signature, team)}
        </>
      }
      subtitle={signature.blurb}
    />
  );
};
